<template>
	<ChoosePlacementForAddOn
		:placements="placements"
		:contexts="contexts"
		:generalPlacements="plySidebarPlacements"
		:service="service"
		:tilesAreActive="tilesAreActive"
		:useSingletonPlacements="isSidebarContextsEnabled"
		v-bind="{ ...$props, ...$attrs }"
		v-on="$listeners"
	/>
</template>

<script>
import { getPlacementsOfService, getPlacementsOfServiceBySlug } from '@/store/modules/placements/actions';
import ChoosePlacementForAddOn from './ChoosePlacementForAddOn.vue';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { getServicePlacements, getServicePlacementsBySlug } from '@/store/modules/placements/getters';
import { getService, getServiceBySlug } from '@/store/modules/apps/getters';
import props from './ChoosePlacementForAddOnDataProvider.props';
import { getPlacementVersion } from '@/store/modules/placements/modules/versions/getters';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
import { getContextsOfService, getContextsOfServiceBySlug } from '@/store/modules/contexts/actions';
import { getContext } from '@/store/modules/contexts/getters';
import { ServiceSlugs } from '@ply-io/ply-front-shared-utilities';
import uniq from 'lodash/uniq';
import { isSidebarContextsEnabled } from '@/store/modules/featureFlags/getters';
export default {
	name: 'ChoosePlacementForAddOnDataProvider',
	props,
	components: { ChoosePlacementForAddOn },
	computed: {
		...mapGettersShorthand({
			getServicePlacements,
			getServicePlacementsBySlug,
			getService,
			getPlacementVersion,
			getServiceBySlug,
			getContext,
			isSidebarContextsEnabled,
		}),
		placements() {
			return this.getServicePlacements(this.selectedAppId)
				.filter((placement) => placement.active)
				.map((placement) => this.enrichPlacementWithActiveVersion(placement, this.selectedAppId));
		},
		contexts() {
			return uniq(this.placements.filter((placement) => !!placement.version.context).map((placement) => placement.version.context)).map(
				(contextId) => this.getContext(contextId)
			);
		},
		plySidebarPlacements() {
			const skipSidebarPlacements =
				!this.isSidebarContextsEnabled || !this.plySidebarService || this.selectedAppId === this.plySidebarService.id;
			if (skipSidebarPlacements) {
				return [];
			}
			return this.getServicePlacementsBySlug(ServiceSlugs.Sidebar)
				.filter((placement) => placement.active)
				.map((placement) => this.enrichPlacementWithActiveVersion(placement, this.plySidebarService.id));
		},
		service() {
			return this.getService(this.selectedAppId);
		},
		plySidebarService() {
			return this.getServiceBySlug(ServiceSlugs.Sidebar);
		},
	},
	methods: {
		...mapActionsShorthand({
			getPlacementsOfService,
			getPlacementsOfServiceBySlug,
			getContextsOfService,
			getContextsOfServiceBySlug,
		}),
		enrichPlacementWithActiveVersion(placement, serviceId) {
			const service = this.getService(serviceId);
			const placementVersion = this.getPlacementVersion(placement.id, service.version);
			const contextExtension = placementVersion.context ? { context: this.getContext(placementVersion.context) } : {};
			return { ...placement, version: placementVersion, ...contextExtension };
		},
	},
	async mounted() {
		await Promise.all([
			this.getContextsOfService({ serviceId: this.selectedAppId }),
			this.getContextsOfServiceBySlug({ slug: ServiceSlugs.Sidebar }),
		]);
		await Promise.all([
			this.getPlacementsOfService({ serviceId: this.selectedAppId }),
			this.getPlacementsOfServiceBySlug({ slug: ServiceSlugs.Sidebar }),
		]);
		this.tilesAreActive = this.embeddedMode || (await ExtensionCommunicationService.doesSupportsSideBar());
	},
	data() {
		return {
			tilesAreActive: false,
		};
	},
};
</script>

<style lang="scss"></style>
